import { syncPackGiftQuantities } from './pf-real-pack-gifts.js?v=20261030-nobag';
import { CartUpdateEvent, ThemeEvents } from '@theme/events';
// Keep free accessories at the garment's quantity after any cart update (Shopify does not sync nested lines).
let busy = false;
document.addEventListener(ThemeEvents.cartUpdate, async (event) => {
  if (busy || event.detail?.source === 'pf-cart-gift-sync') return;
  const cart = event.detail?.data; if (!cart || !Array.isArray(cart.items)) return;
  const mismatch = cart.items.some(g => {
    if (g.properties?._PyreFitGift !== '1') return false;
    const parent = cart.items.find(l => l.key === g.parent_relationship?.parent_key);
    const expected = parent && g.properties._PyreFitGiftKind !== 'bag' ? (g.properties._PyreFitGiftKind === 'warmer' ? 1 : parent.quantity) : 0;
    return g.quantity !== expected;
  });
  if (!mismatch) return;
  busy = true;
  try {
    const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(e => e.dataset.sectionId).filter(Boolean))];
    const updated = await syncPackGiftQuantities(cart, sectionIds);
    if (updated !== cart) document.dispatchEvent(new CartUpdateEvent(updated, 'pf-cart-gift-sync', { source: 'pf-cart-gift-sync', itemCount: updated.item_count, sections: updated.sections }));
  } catch (err) { console.warn('gift sync', err); } finally { busy = false; }
});
